import { createSelector } from 'reselect'

export const getState = (state) => state.ui;
export const getLayouts = (state) => state.ui.layouts;
export const getLayoutElements = (state) => state.ui.layoutElements;
export const getFlashMessages = (state) => state.ui.flashMessages;




// WEBPACK FOOTER //
// ./src/storeState/ui/selectors.js